import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/arrival-notice/dispatchInsert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/arrival-notice/dispatchUpdate',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/arrival-notice/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/arrival-notice/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/arrival-notice/dispatch/export',
        method: 'get',
        params,
        responseType: 'blob'
    })
}
export const downloadImportTemplate = () => {
    return request({
        url: '/api/produce/arrival-notice/import-template',
        method: 'get',
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/arrival-notice/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}
export const importExcel = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/api/produce/arrival-notice/import-excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const sendRailwayArrival = (id) => {
    return request({
        url: '/api/produce/arrival-notice/send-railway-arrival',
        method: 'post',
        params: {
            id
        }
    })
}

export const getRailwayArrivalSendLock = () => {
    return request({
        url: '/api/produce/arrival-notice/send-lock',
        method: 'get'
    })
}

